import { render } from "./IzinKaryawan.vue?vue&type=template&id=4566bc4e&scoped=true"
import script from "./IzinKaryawan.vue?vue&type=script&lang=js"
export * from "./IzinKaryawan.vue?vue&type=script&lang=js"

import "./IzinKaryawan.vue?vue&type=style&index=0&id=4566bc4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4566bc4e"]])

export default __exports__